module.exports = __webpack_public_path__ + "static/media/justfollowit-mockups.be41e07f.png";